import { useEffect, useState } from "react";
import { limitString } from "src/Common/function";

// canManage defaults to true so the row stays interactive for existing behavior;
// notification:read-only users get read-only rows (no click / no cursor).
const Receivers = ({ woRecipients, poRecipients, setUserSelectModalShown, setFlow, canManage = true }) => {
  return (
    <>
      <p className="font-OpenSansMedium text-[13px] text-black w-[30%]">Receivers</p>
      <div
        onClick={
          canManage
            ? () => {
                setUserSelectModalShown(true);
                setFlow(0);
              }
            : undefined
        }
        className={`h-[30px] border-[1px] rounded-md border-gray-200 flex items-center px-2 ${
          canManage ? "cursor-pointer" : "cursor-default"
        }`}
      >
        <p className="font-OpenSansMedium text-[13px] text-black">{limitString(woRecipients, 120)}</p>
      </div>
      <div
        onClick={
          canManage
            ? () => {
                setUserSelectModalShown(true);
                setFlow(1);
              }
            : undefined
        }
        className={`h-[30px] border-[1px] rounded-md border-gray-200 flex items-center px-2 ${
          canManage ? "cursor-pointer" : "cursor-default"
        }`}
      >
        <p className="font-OpenSansMedium text-[13px] text-black">{limitString(poRecipients, 120)}</p>
      </div>
    </>
  );
};

export default Receivers;
